import XyEditor from './XyEditor';
import ZoomEditor from './ZoomEditor';

const IgImgPlacement = ({ fgImgPositionX, fgImgPositionY, setFgImgPositionX, setFgImgPositionY, fgImgZoom, setFgImgZoom }) => {
  return (
    <div className='flex flex-col gap-2'>
      <div className='flex gap-6 items-center'>
        <XyEditor
          xValue={fgImgPositionX}
          yValue={fgImgPositionY}
          setXValue={setFgImgPositionX}
          setYValue={setFgImgPositionY}
        />
        <ZoomEditor zoomLevel={fgImgZoom} setZoomLevel={setFgImgZoom} />
      </div>
      <div className='self-start text-gray-500 text-sm italic'>Use drag & drop to move the image</div>

    </div>
  );
};

export default IgImgPlacement;

